<template>
  <form autocomplete="on" class="form-horizontal container px-0" @submit="onSubmit">
    <h3>
      <i class="fas fa-user"></i> Particular
    </h3>
    <div class="alert alert-danger" v-if="error">{{error}}</div>
    <div class="row">
      <div class="form-group col-12">
        <label for="email">Email</label>
        <span v-if="errors.email && touched.email" class="formError">{{ errors.email }}</span>
        <input
          placeholder="Email"
          @input="validate"
          @blur="handleTouched"
          required
          type="email"
          name="email"
          id="email"
          v-model="form.email"
          class="form-control"
          autocomplete="email"
        />
      </div>

      <div class="form-group col-12">
        <label for="confirmar_email">Confirmar email</label>
        <input
          required
          type="email"
          id="confirmar_email"
          v-model="form.confirmarEmail"
          class="form-control"
          placeholder="Confirmar Email"
        />
      </div>
    </div>
        <div class="row">
      <div class="form-group col-12">
        <label for="password">Contraseña</label>
        <span v-if="errors.password && touched.password" class="formError">{{ errors.password }}</span>
        <input
          placeholder="Contraseña"
          @input="validate"
          @blur="handleTouched"
          required
          type="password"
          name="password"
          id="password"
          v-model="form.password"
          class="form-control"
          autocomplete="password"
        />
      </div>

      <div class="form-group col-12">
        <label for="confirmar_password">Confirmar contraseña</label>
        <input
          required
          type="password"
          id="confirmar_password"
          v-model="form.confirmarPassword"
          class="form-control"
          placeholder="Confirmar Contraseña"
        />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-12 col-md-6">
        <label for="nombre">Nombre/s</label>
        <span v-if="errors.nombre && touched.nombre" class="formError">{{ errors.nombre }}</span>
        <input
          placeholder="Nombre/s"
          @input="validate"
          @blur="handleTouched"
          v-model="form.nombre"
          required
          id="nombre"
          name="nombre"
          class="form-control"
          autocomplete="given-name"
          type="text"
        />
      </div>
      <div class="form-group col-sm-12 col-md-6">
        <label for="apellido">Apellido/s</label>
        <span v-if="errors.apellido && touched.apellido" class="formError">{{ errors.apellido }}</span>
        <input
          placeholder="Apellido/s"
          @input="validate"
          @blur="handleTouched"
          id="apellido"
          name="apellido"
          autocomplete="family-name"
          required
          v-model="form.apellido"
          class="form-control"
          type="text"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-4">
        <label for="tipo_documento">Tipo</label>
        <select id="tipo_documento" v-model="form.tipoDocumento" class="form-control">
          <option v-for="(tipo, index) in tiposDocumento" :key="index">{{tipo}}</option>
        </select>
      </div>
      <div class="form-group col-8">
        <label for="documento">Documento</label>
        <span v-if="errors.documento && touched.documento" class="formError">{{ errors.documento }}</span>
        <input
          placeholder="12345678"
          @input="validate"
          @blur="handleTouched"
          required
          type="number"
          name="documento"
          id="documento"
          v-model="form.documento"
          class="form-control"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-4">
        <label for="tipo_indenficador_fiscal">Cuil/Cuil</label>
        <select
          id="tipo_indenficador_fiscal"
          v-model="form.tipoIdentificadorFiscal"
          class="form-control"
          required
        >
          <option value="CUIL">CUIL</option>
          <option value="CUIT">CUIT</option>
        </select>
      </div>
      <div class="form-group col-8">
        <label for="indenficador_fiscal">CUIT/CUIL</label>
        <span v-if="errors.identificadorFiscal && touched.identificadorFiscal" class="formError">{{ errors.identificadorFiscal }}</span>
        <input
          placeholder="001234567800"
          @input="validate"
          @blur="handleTouched"
          required
          type="number"
          name="identificadorFiscal"
          id="indenficador_fiscal"
          v-model="form.identificadorFiscal"
          class="form-control"
        />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-12">
        <label for="fecha_nacimiento">Fecha de nacimiento</label>
        <span v-if="errors.fechaNacimiento && touched.fechaNacimiento" class="formError">{{ errors.fechaNacimiento }}</span>
        <input
          required
          @input="validate"
          @blur="handleTouched"
          v-model="form.fechaNacimiento"
          type="text"
          name="fechaNacimiento"
          placeholder="dd/mm/aaaa"
          id="fecha_nacimiento"
          class="form-control"
        />
      </div>
      <div class="form-group col-12">
        <label for="telefono">Teléfono</label>
        <input type="tel" class="form-control" v-model="form.telefono" />
      </div>
    </div>
   
    <div class=" col-12 pb-3  alert alert-success" >
      <div class="form-check">
        <input
          v-model="sameAddress"
          type="checkbox"
          class="form-check-input"
          id="domicilio-iguales"
        />
        <label
          class="form-check-label"
          for="domicilio-iguales"
        ><i class="fas fa-map-marker-alt"></i> Mi domicilio de envio y legal son iguales</label>
      </div>
    </div>
 
    <domicilio
      :titulo="sameAddress ? 'Domicilio Legal y Domicilio de entrega' : 'Domicilio de entrega'"
      v-model="form.domicilio"
    ></domicilio>
    <domicilio
      v-if="!sameAddress"
      :autocomplete="false"
      titulo="Domicilio Legal"
      v-model="form.domicilioLegal"
    ></domicilio>
    <div class="row">
      <div class="form-group col-12">
        <label for="referencia" class="col-sm-12 control-label">¿Cómo llegaste a SAREXPRESS?</label>
        <select id="referencia" v-model="form.referencia" class="form-control">
          <option disabled selected>Seleccione opción...</option>
          <option>Un amigo o familiar me habló del servicio</option>
          <option>A través de Google</option>
        </select>
      </div>
    </div>
    <terminos-y-condiciones :value="terminosYCondiciones" :onTerminosPressed="onTerminosPressed"></terminos-y-condiciones>
    <div class="row">
      <div class="col-12 pt-2 pb-1">
        <button type="submit" :disabled="loading" class="btn btn-primary btn-block">Registrarse</button>
      </div>
    </div>
  </form>
</template>
<script>
import { createParticularClient } from "@/service/api";
import TerminosYCondiciones from "./TerminosYCondiciones.vue";
import Domicilio from "./Domicilio";
import { errorMessages,validateRequiredFields } from "../../constants";
export default {
  props: { tiposDocumento: { type: Array }, onSuccess: { type: Function } },
  components: { Domicilio, TerminosYCondiciones },
  data() {
    return {
      error: null,
      errors: {
        nombre: errorMessages.required,
        apellido: errorMessages.required,
        documento: errorMessages.required,
        identificadorFiscal: errorMessages.required,
        email: errorMessages.required,
        password: errorMessages.required,
        fechaNacimiento: errorMessages.required,
      },
      touched: {
        nombre: false,
        apellido: false,
        documento: false,
        identificadorFiscal: false,
        email: false,
        password: false,
        fechaNacimiento: false,
      },
      loading: false,
      sameAddress: false,
      terminosYCondiciones: false,
      form: {
        nombre: "",
        apellido: "",
        tipoDocumento: "DNI",
        documento: "",
        identificadorFiscal: "",
        tipoIdentificadorFiscal: "CUIL",
        email: "",
        password: "",
        confirmarPassword: "",
        confirmarEmail: "",
        fechaNacimiento: "",
        telefono: "",
        referencia: "Seleccione opción...",
        domicilio: {
          direccion: "",
          piso: "",
          departamento: "",
          codigoPostal: "",
          ciudad: "",
          provincia: "",
          isDomicilioValid:false,
        },
        domicilioLegal: {
          direccion: "",
          piso: "",
          departamento: "",
          codigoPostal: "",
          ciudad: "",
          provincia: "",
          isDomicilioValid:false,
        },
      },
    };
  },
  methods: {
    onTerminosPressed() {
      this.terminosYCondiciones = !this.terminosYCondiciones;
    },
    validate(){
      this.errors={
        nombre: '',
        apellido: '',
        documento: '',
        identificadorFiscal: '',
        email: '',
        password: '',
        fechaNacimiento: '',
        telefono: '',
      }
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.form.email)) {
        this.errors.email = errorMessages.invalidEmail;
      }
      if (!/^[0-9-]*$/.test(this.form.identificadorFiscal)){
        this.errors.cuit=errorMessages.invalidCuit
      }
      validateRequiredFields(['nombre','apellido','documento','identificadorFiscal','email','password','fechaNacimiento'],this.form,this.errors)
    },
    handleTouched(e){
      this.touched[e.target.name]=true
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = null;
      if (this.form.email !== this.form.confirmarEmail) {
        window.scrollTo(0, 0);
        return (this.error = "Los emails no coinciden");
      }
      if(this.form.password !== this.form.confirmarPassword) {
        window.scrollTo(0,0);
        return this.error = "Las contraseñas no coinciden"
      }
      if (!this.terminosYCondiciones) {
        window.scrollTo(0, 0);
        return (this.error = "Debe aceptar los términos y condiciones");
      }
      let isFormValid=true

      Object.keys(this.errors).map(key=>{
        if (this.errors[key]){
          isFormValid=false
        }
      })

      if (isFormValid===false||this.form.domicilio.isDomicilioValid===false||(this.sameAddress===false&&this.form.domicilioLegal.isDomicilioValid===false)){
        window.scrollTo(0, 0);
        return (this.error = "Hay errores en el formulario, revisar e intentar nuevamente");
      }
      
      if (!this.loading) {
        this.loading = true;
        let domicilioLegal = this.sameAddress
          ? this.form.domicilio
          : this.form.domicilioLegal;
        createParticularClient({
          tipo_documento: this.form.tipoDocumento,
          documento: this.form.documento,
          tipo_identificador_fiscal: this.form.tipoIdentificadorFiscal,
          identificador_fiscal: this.form.identificadorFiscal,
          telefono: this.form.telefono,
          como_llegaste: this.form.referencia,
          fecha_nacimiento: this.form.fechaNacimiento,
          password: this.form.password,
          user: {
            first_name: this.form.nombre,
            last_name: this.form.apellido,
            username: this.form.email,
          },
          domicilio: {
            direccion: this.form.domicilio.direccion,
            piso: this.form.domicilio.piso,
            departamento: this.form.domicilio.departamento,
            codigo_postal: this.form.domicilio.codigoPostal,
            ciudad: this.form.domicilio.ciudad,
            provincia: this.form.domicilio.provincia,
          },
          domicilio_legal: {
            direccion: domicilioLegal.direccion,
            piso: domicilioLegal.piso,
            departamento: domicilioLegal.departamento,
            codigo_postal: domicilioLegal.codigoPostal,
            ciudad: domicilioLegal.ciudad,
            provincia: domicilioLegal.provincia,
          },
        })
          .then((response) => {
            this.loading = false;
            this.error = null;
            if (response.status >= 200 && response.status < 300) {
              this.onSuccess();
            } else {
              this.error = "Ya existe un usuario con ese email";
              window.scrollTo(0, 0);
            }
          })
          .catch(() => {
            this.loading = false;
            this.error = "Ocurrio un error, intentelo más tarde";
            window.scrollTo(0, 0);
          });
      }
    },
  },
};
</script>
